import React, { useState } from 'react';
import { X } from 'lucide-react';
import styles from '../../styles/chat-history.module.css';
import { useTranslation } from 'react-i18next';

const ChatHistoryModal = ({
  isMobile = false,
  isChatOpen,
  isVectorClicks,
  setIsChatOpen,
  newChatAction,
  setChatWindowOpens,
  groupedChats,
  setVectorClicks,
  setNewChatOpens,
  setNewChatSelected,
}) => {
  const [selectedId, setSelectedId] = useState(null);
  const { t } = useTranslation(['chat']);
  const timeCategoryLabels = {
    Today: t('chat:history.timeCategories.today'),
    Yesterday: t('chat:history.timeCategories.yesterday'),
    Earlier: t('chat:history.timeCategories.earlier'),
  };

  return (
    <>
      {(isChatOpen || isVectorClicks) && (
        <div className={`${styles.historyModal} ${isMobile ? styles.historyModalMobile : ''}`}>
          <div className={styles.historyHeader}>
            <div className={styles.historyHeaderRow}>
              <div className={styles.historyHeaderLeft}>
                {isVectorClicks && (
                  <button
                    className={styles.historyVectorButton}
                    onClick={() => {
                      setVectorClicks(false);
                      setIsChatOpen(false);
                      setNewChatOpens(false);
                    }}
                    onFocus={(e) => e.target.blur()}
                    tabIndex={-1}
                  >
                    <img
                      src="/vector.png"
                      alt="VectorImg"
                      className={styles.historyVectorIcon}
                      draggable="false"
                    />
                  </button>
                )}
                <div className={styles.historyHeaderBrand}>
                  <img
                    src="/fundmoreai.png"
                    alt="fundmore.ai"
                    className={styles.historyHeaderLogo}
                  />
                  <div className={styles.historyHeaderWordmark}>
                    <span className={styles.historyHeaderFund}>fund</span>
                    <span className={styles.historyHeaderMore}>more</span>
                    <span className={styles.historyHeaderAi}>.ai</span>
                  </div>
                </div>
                <span className={styles.historyHeaderLabel}>{t('chat:history.title')}</span>
              </div>
              <div className={styles.historyHeaderRight}>
                <button
                  type="button"
                  className={styles.historyCloseButton}
                  onClick={() => {
                    setIsChatOpen(false);
                    setVectorClicks(false);
                    setNewChatOpens(false);
                  }}
                >
                  <X
                    className={styles.historyCloseIcon}
                  />
                </button>
              </div>
            </div>
          </div>
          <>
                <div className={styles.historyNewChat}>
                  <button
                    type="button"
                    onClick={() => {
                      setNewChatSelected(true);
                      newChatAction();
                    }}
                    className={styles.historyNewChatButton}
                  >
                    <span>{t('chat:history.newChat')}</span>
                  </button>
                </div>

            <div className={styles.historyList}>
              <div className={styles.historyScroll}>
                {Object.entries(groupedChats)?.map(
                  ([timeCategory, chats]) =>
                    chats?.length > 0 && (
                      <div key={timeCategory} className={styles.historySection}>
                        <div className={styles.historySectionTitle}>
                          {timeCategoryLabels[timeCategory] ?? timeCategory}
                        </div>
                        <div className={styles.historyItems}>
                          {chats?.map((chat) => (
                            <div
                              key={chat?.chat_id}
                              className={`${styles.historyItem} ${
                                selectedId === chat?.chat_id
                                  ? styles.historyItemActive
                                  : ''
                              }`}
                              onClick={() => {
                                setVectorClicks(false);
                                setIsChatOpen(false);
                                setNewChatOpens(false);
                                setChatWindowOpens(chat?.chat_id);
                                setSelectedId(chat?.chat_id);
                              }}
                              title={chat?.title ?? `Chat ${chat?.chat_id}`}
                            >
                              <span className={styles.historyItemText}>
                                {chat?.title ?? `Chat ${chat?.chat_id}`}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )
                )}
              </div>
            </div>
          </>
        </div>
      )}
    </>
  );
};
export default ChatHistoryModal;
